var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_container app dashboard"},[_c('section',[_c('h1',[_vm._v(_vm._s(_vm.translations.dashboard.title))]),_c('h3',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.translations.dashboard.subtitle))]),_c('span',{staticClass:"line gray"})]),_c('comp_dashboard'),_c('comp_modal_overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }